import ClassifiedCategory from ".";

export const classifiedsCategoryRoutes = () => [
  {
    path: "/admin/classifieds-categories",
    component: ClassifiedCategory,
    layout: "admin",
    routeType: "admin",
    title: "Classifieds Management",
  },
];
